import React, { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO } from "../data/media";

const LINKS = [
  { to: "/", label: "Home", tid: "home" },
  { to: "/services", label: "What's Possible", tid: "services" },
  { to: "/portfolio", label: "Work", tid: "work" },
  { to: "/about", label: "About", tid: "about" },
  { to: "/contact", label: "Contact", tid: "contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => setOpen(false), [loc.pathname]);
  useEffect(() => {
    const onS = () => setScrolled(window.scrollY > 20);
    onS();
    window.addEventListener("scroll", onS, { passive: true });
    return () => window.removeEventListener("scroll", onS);
  }, []);

  const goTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <header
      data-testid="nav"
      className="fixed left-0 top-0 z-[70] w-full border-b transition-colors duration-500"
      style={{
        backdropFilter: "blur(24px)",
        background: scrolled ? "rgba(5,5,5,0.8)" : "rgba(5,5,5,0.35)",
        borderColor: scrolled ? "rgba(255,255,255,0.06)" : "transparent",
      }}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <Link to="/" onClick={goTop} data-testid="nav-logo" className="flex items-center">
          <img src={LOGO} alt="AberCal" className="h-8 w-auto sm:h-9" />
        </Link>

        <nav className="hidden items-center gap-10 md:flex">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`nav-link-${l.tid}`} end={l.to === "/"}
              onClick={() => l.to === "/" && goTop()}
              className={({ isActive }) =>
                `hover-underline text-xs uppercase tracking-[0.25em] transition-colors ${isActive ? "active text-[var(--text)]" : "text-[var(--text-2)] hover:text-[var(--text)]"}`
              }>
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" data-testid="nav-cta" className="btn-gold">Start a Conversation</Link>
        </nav>

        <button data-testid="nav-menu-toggle" className="text-[var(--text)] md:hidden" onClick={() => setOpen((o) => !o)} aria-label="Menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile" className="border-t border-white/5 bg-[rgba(5,5,5,0.97)] px-6 py-6 md:hidden">
          <div className="flex flex-col gap-5">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.to === "/"}
                className={({ isActive }) => `text-sm uppercase tracking-[0.25em] ${isActive ? "text-gold" : "text-[var(--text-2)]"}`}>
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
